import { useStoreon } from 'storeon/react';
import { LoyaltyStore } from '../../reducers';
import { ErrorWithStatus } from '../../api/error-with-status';

interface IUseLoyaltyDataOutput {
  keycardPro: boolean | null;
  loyaltyAccountIdentifier: string | null;
  fetchedLoyaltyAccountSuccess: boolean;
  points: number | null;
  fetchedLoyaltyPointsSuccess: boolean;
  fetchedLoyaltyRankSuccess: boolean;
  fetchLoyaltyPointsLoading: boolean;
  fetchLoyaltyPointsError: ErrorWithStatus | null;
  fetchLoyaltyRankLoading: boolean;
  fetchLoyaltyRankError: ErrorWithStatus | null;
  rankLabel: string | null;
}

export const useLoyaltyData = (): IUseLoyaltyDataOutput => {
  const { loyalty } = useStoreon<LoyaltyStore>('loyalty');

  return {
    fetchedLoyaltyAccountSuccess: loyalty.fetchLoyaltyAccount.fetched && !loyalty.fetchLoyaltyAccount.error,
    keycardPro: loyalty.loyaltyTypePRO,
    loyaltyAccountIdentifier: loyalty.loyaltyAccountIdentifier,
    fetchedLoyaltyPointsSuccess: loyalty.fetchLoyaltyPoints.fetched && !loyalty.fetchLoyaltyPoints.error,
    fetchLoyaltyPointsLoading: loyalty.fetchLoyaltyPoints.loading,
    fetchLoyaltyPointsError: loyalty.fetchLoyaltyPoints.error,
    points: loyalty.points,
    fetchedLoyaltyRankSuccess: loyalty.fetchLoyaltyRank.fetched && !loyalty.fetchLoyaltyRank.error,
    fetchLoyaltyRankLoading: loyalty.fetchLoyaltyRank.loading,
    fetchLoyaltyRankError: loyalty.fetchLoyaltyRank.error,
    rankLabel: loyalty.rankLabel,
  };
};
